/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-24 11:00:46                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-31 13:10:40                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Switch: tailwind switch wrapper
*/

/* Imports */
import { Switch as S } from "@material-tailwind/react";
/***/

/**
* Switch: tailwind switch wrapper
* used to simplify code, apply default style 
* @param checked - checked state
* @param onChange - checked state change event
*/
export default function Switch({
  checked,
  onChange,
  disabled,
  className
}: {
  checked?: boolean,
  onChange: (e: boolean) => void,
  disabled?: boolean,
  className?: string
}) {
  return (
    <S className={`slider h-full w-full rounded-full checked:bg-blue-600 disabled:checked:!bg-[#5B616E] bg-blue-gray-100 disabled:bg-[#D8DBDF] disabled:opacity-100 ${className ?? ""}`}
      ripple={false}
      checked={checked}
      disabled={disabled}
      containerProps={{
        className: "w-11 h-6 rounded-full cursor-pointer focus-within:ring-2 focus-within:ring-blue-600 focus-within:ring-offset-2",
      }}
      circleProps={{
        className: "before:hidden left-0.5 border-none bg-white shadow-sm",
      }}
      onChange={(e) => onChange(e.target.checked)} />
  );
}
/***/
